import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("opik_token", data.token);
    setUser(data);
    return data;
  }, []);
  const register = useCallback(async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    if (data.token) localStorage.setItem("opik_token", data.token);
    setUser(data);
    return data;
  }, []);
  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { void e; }
    localStorage.removeItem("opik_token");
    setUser(false);
  }, []);
  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch { return null; }
  }, []);

  // Stable provider value — only re-renders consumers when state actually changes.
  const value = useMemo(
    () => ({ user, loading, login, register, logout, refreshUser, formatApiErrorDetail }),
    [user, loading, login, register, logout, refreshUser]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
